













































































































import BasicTs from '@/components/mixins/basicts.vue'
import moment from "moment-timezone";
import { Component, Vue, Mixins } from 'vue-property-decorator'
import * as types from '@/lib/definition/types'
moment.locale('ja')

@Component({
  mixins: [BasicTs]
})
export default class PrivacyWord extends Mixins(BasicTs) {
  private authCode = ''
  private addingObj = new types.PrivacyWordConstructor()
  private dialogAdding = false
  private objectToDelete = new types.PrivacyWordConstructor()
  private dialogDeleting = false
  private requestParam: any = null
  private timer: any = null
  async mounted() {
  }
  async masterReady () {
    if (!this.$store.getters['Login/isAdmin']) {
      // redirect to home when you are not admin
      this.$router.push(this.site.deployFolder + "/")
    }
    await this.search()
    this.timer = setInterval(this.search, 10000)
  }
  async search () {
    this.authCode = await this.$store.direct.dispatch.Users.getAuthCode()
  }
}
